var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn new-scoring-request"},[_c(_vm.scoringForm,{tag:"component",attrs:{"model":_vm.scoringModelById(_vm.modelId),"customer":_vm.customer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }